import { combineReducers, type UnknownAction } from '@reduxjs/toolkit';

import { replaceVehicleValue } from 'Core/actions/fitmentSearch/index';
import { createIsolatedReducer } from 'Core/reducers/common';
import { fitmentResponseReducer, fixRequestDueToResponse } from 'Core/reducers/fitmentSearch/common';
import fields from 'Core/reducers/fitmentSearch/fields';

import isolatedKey from './isolatedKey';
import request from './request';

const baseIsolatedHeader = createIsolatedReducer(
  isolatedKey,
  combineReducers({
    request,
    response: fitmentResponseReducer,
    fields,
  }),
);

type IsolatedHeaderState = ReturnType<typeof baseIsolatedHeader>;

const isolatedHeader = (state: IsolatedHeaderState | undefined, action: UnknownAction): IsolatedHeaderState =>
  baseIsolatedHeader(fixRequestDueToResponse(state, replaceVehicleValue.match(action)), action);

export default isolatedHeader;
